import React, { useState } from 'react';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import { contactApi } from '../services/api';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setStatus('');
    try {
      await contactApi.send(form);
      setForm({ name: '', email: '', message: '' });
      setStatus('وصلت رسالتك، شكراً لتواصلك مع الأرشيف.');
    } catch (error) {
      setStatus(error.message || 'تعذر الإرسال الآن');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout>
      <Seo title="تواصل" />
      <PageHero eyebrow="الأرشيف" title="تواصل معنا" subtitle="للإسهام بسيرة، صورة، قصيدة أو تصحيح معلومة." />
      <div className="container-responsive max-w-xl py-12">
        <form onSubmit={handleSubmit} className="space-y-4 rounded-[2rem] bg-white p-8 shadow-large dark:bg-stone-900">
          <input className="form-input" placeholder="الاسم" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} required />
          <input className="form-input" type="email" placeholder="البريد الإلكتروني" value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} required />
          <textarea className="form-input min-h-[140px]" placeholder="رسالتك" value={form.message} onChange={(e) => setForm((p) => ({ ...p, message: e.target.value }))} required minLength={8} />
          <button type="submit" className="btn btn-primary w-full" disabled={saving}>{saving ? 'جاري الإرسال...' : 'إرسال'}</button>
          {status && <p className="text-center text-sm">{status}</p>}
        </form>
      </div>
    </Layout>
  );
};

export default ContactPage;
